var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../ts/components/LazyLoader';
export class SingleProject extends Component {
    constructor() {
        super('SingleProject', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Toggle information button
            $('.btn-toggle-information').on('click', (event, button) => {
                event.preventDefault();
                button.toggleClass('is-active');
                const className = $(window).width() >= 1200 ? 'd-xl-none' : 'is-open';
                console.log($('.page-project__information').hasClass(className));
                $('.page-project__information').toggleClass(className);
                if ($(window).width() < 1200) {
                    if (button.hasClass('is-active')) {
                        $('body').addClass('bg-beige-100');
                        setTimeout(() => {
                            $('.page-project__container').addClass('opacity-0');
                        }, 170);
                    }
                    else {
                        $('.page-project__container').removeClass('opacity-0');
                        $('body').removeClass('bg-beige-100');
                    }
                }
            });
            $('.page-project__information').on('click', (event, information) => {
                if ($(window).width() >= 1200)
                    return;
                if (information.hasClass('is-open'))
                    $('.btn-toggle-information.d-xl-none').trigger('click');
            });
            // Vertical mousewheel scroll for horizontal scrolling
            const container = $('.page-project__gallery');
            container.on('wheel', (event) => {
                container.get(0).scrollLeft += event.deltaY;
                LazyLoader.checkImageVisibility();
            });
            // Back button behavior
            $('.btn-back').on('click', (event) => {
                if (!document.referrer || (document.referrer && !document.referrer.includes(window.location.hostname)))
                    return;
                event.preventDefault();
                sessionStorage.setItem('reset-scroll-position', 'true');
                window.history.back();
            });
            // Footer height update on resize
            $(window).on('resize', () => {
                this.updateFooterHeight();
            });
            this.updateFooterHeight();
            setTimeout(() => {
                this.updateFooterHeight();
            }, 1000);
            this.success();
        });
    }
    updateFooterHeight() {
        $('body').css('--footer-project-height', `${$('body > .btn-toggle-information').height()}px`);
    }
}
